import React from 'react';

const LivestreamingView = () => {
	return <div>LivestreamingView</div>;
};

export default LivestreamingView;
